module.exports = __webpack_public_path__ + "img/la-defence-tours-Pascal-slide-1.34c0b5db.png";